import api from "@/api/axios";
import { ElMessage } from 'element-plus'

export default {
  namespaced: true,
  state: {
    tags: [],
    isLoading: false,
    error: null
  },
  getters: {
    allTags: (state) => state.tags
  },
  mutations: {
    SET_TAGS(state, tags) {
      state.tags = tags;
    },
    SET_LOADING(state, status) {
      state.isLoading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
      if (error) {
        ElMessage({
          message: error,
          type: 'error',
          duration: 2000
        });
      }
    }
  },
  actions: {
    async fetchTags({ commit }) {
      try {
        commit('SET_LOADING', true);
        const response = await api.get('/tags/list');
        if (response.data.status === 200) {
          commit('SET_TAGS', response.data.data);
        } else {
          commit('SET_ERROR', response.data.msg);
        }
      } catch (error) {
        console.error('获取标签列表失败:', error);
        commit('SET_ERROR', '获取标签列表失败');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  }
}; 